import { useState } from "react";

import { Box, Stack, Typography } from "@mui/material";

import CustomSelection from "../../../../helper-components/form/CustomSelection";
import CustomButton from "../../../../helper-components/input/CustomButton";

import { getEllipsis } from "../../../../helper-functions/shared/miscUtils";
import { getPatientDisplayName } from "../../../../helper-functions/shared/patientDisplay";
import { querySelectPatients } from "../../../../helper-functions/api/patientQueries";

export default function MoveExaminationDialog(props) {
    const { examination, onCancel, onConfirm } = props;
    const [selected, setSelected] = useState(null);
    const [confirming, setConfirming] = useState(false);

    const currentName = getPatientDisplayName(examination?.patient);
    const nextName = selected ? getPatientDisplayName(selected) : "";

    if (confirming && selected) {
        return (
            <Box className="box">
                <Typography variant="body2" sx={{ mb: 2 }}>
                    Move this examination from {currentName} to {nextName}? It will leave {currentName} and show under {nextName}. The chart itself is not changed.
                </Typography>
                <Stack direction="row" spacing={1} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
                    <CustomButton {...props} title="Back" onClick={() => setConfirming(false)} className="button" fullWidth variant="outlined" />
                    <CustomButton {...props} title="Confirm move" onClick={() => onConfirm(selected)} className="button" fullWidth />
                </Stack>
            </Box>
        );
    }

    return (
        <Box className="box">
            <Typography variant="body2" sx={{ mb: 1 }}>
                This chart is currently on {currentName}. Choose the patient it should belong to.
            </Typography>
            <CustomSelection
                {...props}
                selected={selected ? [selected] : []}
                callback={(rows = []) => setSelected(rows?.[0] || null)}
                query={querySelectPatients}
                getPrimarySearchText={(el) => [el?.patient_identifier, el?.first_name, el?.last_name].filter(Boolean).join(" ")}
                getSecondarySearchText={(el) => `${el?.notes || ""} #${el?.id ?? ""}`.trim()}
                getPrimaryText={(el) => getPatientDisplayName(el)}
                getSecondaryText={(el) => getEllipsis(el?.notes, 50)}
            />
            <Stack direction="row" spacing={1} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
                <CustomButton {...props} title="Cancel" onClick={onCancel} className="button" fullWidth variant="outlined" />
                <CustomButton
                    {...props}
                    title="Continue"
                    onClick={() => setConfirming(true)}
                    className="button"
                    fullWidth
                    disabled={!selected || selected.id === examination?.patient_id}
                />
            </Stack>
        </Box>
    );
}
